import { store } from "@/internal";
import { Route } from "vue-router";
import { Callback } from "./types/types";

export default class RouterUtils {
  public idRegex = "[1-9]{1}\\d{0,}";
  public checkIfAuthenticated(to: Route, from: Route, next: any) {
    const isLogged = store.getters["authModule/isLogged"];
    if (!isLogged && to.name !== "oauth-callback" && to.name !== "home") {
      next({ name: "home" });
    }

    next();
  }
  public noAuthenticated(to: Route, from: Route, next: any) {
    const isLogged = store.getters["authModule/isLogged"];
    if (isLogged) {
      next("/");
    } else {
      next();
    }
  }
  public isAllowedGuard(
    policy: string,
    to: Route,
    from: Route,
    next: Callback
  ) {
    if (store.getters["authModule/hasPermission"](policy)) {
      next();
    } else {
      next({ name: "forbidden" });
    }
  }
}
